module.exports = __webpack_public_path__ + "media/assets/icons/cross-d3978e75e90d66e5c8dc05e7f462c623.svg";